import React from "react";
import "../assets/css/Signin.css";
import loginHero from "../assets/images/cloud-office-login-hero.png";

/**
 * Shared Business OS–style auth shell (hero + form panel).
 * Matches eats-business-web EatsAppLogin / PartnerLogin layout.
 */
function AuthShell({
  eyebrow = "Staff access for",
  title = "Cloud Office OS",
  subtitle = "CRM, projects, HR, finance, and daily work from one office platform.",
  children,
}) {
  return (
    <div className="signin-page">
      <div className="signin-left">
        <img src={loginHero} alt="Cloud office operations" className="signin-hero" />
        <div className="signin-left-overlay">
          <p className="signin-left-eyebrow">{eyebrow}</p>
          <h1 className="signin-left-title">{title}</h1>
          <p className="signin-left-subtitle">{subtitle}</p>
        </div>
      </div>
      <div className="signin-right">
        <div className="signin-form-wrap">{children}</div>
      </div>
    </div>
  );
}

export function AuthBrandMark({ logo = "office" }) {
  const isOffice = logo === "office" || logo === "tumma";
  const src = isOffice
    ? `${process.env.PUBLIC_URL || ""}/office-logo.png`
    : `${process.env.PUBLIC_URL || ""}/business-os-logo.png`;
  const alt = "Cloud Office";
  const brandClass = isOffice ? "signin-brand signin-brand--office" : "signin-brand";

  return (
    <div className={brandClass} aria-label={alt}>
      <img src={src} alt={alt} className="signin-brand__logo" />
    </div>
  );
}

export default AuthShell;
